<div class="sector" [class.lang-en]="languageService.userLanguage === 'en'">
    <span *ngIf="sectorItem.xID && key"
          class="sector-part xid flex-1">
        {{sectorItem.xID}}
    </span>

    <div class="sector-part departure" *ngIf="sectorItem.begin">
        <div>{{ setDateFromOffset() | dateIgnoreOffset: dateService.dateFormats.momentMedium }}</div>
    </div>

    <div class="sector-part from-to">
        <div class="from-to-part">
            <div>
                <strong> {{ getAirportCode(sectorItem.from) }} </strong>
            </div>
            <div *ngIf="isValidDate(sectorItem.begin)">
                <em>
                    {{ getDate(sectorItem.begin) | dateIgnoreOffset: dateService.dateFormats.momentTime }}
                </em>
            </div>
        </div>

        <div class="from-to-part-arrow">
            <fa-icon [icon]="iconArrowRight"></fa-icon>
        </div>

        <div class="from-to-part">
            <div>
                <strong> {{ getAirportCode(sectorItem.to) }} </strong>
            </div>
            <div *ngIf="isValidDate(sectorItem.end)">
                <em>
                    {{ getDate(sectorItem.end) | dateIgnoreOffset: dateService.dateFormats.momentTime }}
                    <sup *ngIf="dayDiff" class="small">{{dayDiff}}</sup>
                </em>
            </div>
        </div>

    </div>
    <div class="sector-part duration" *ngIf="sectorItem.duration">
        {{ (sectorItem.duration.minutes || sectorItem.duration.minute) |duration }}
    </div>
    <div class="sector-part carrier">
        <div>
            <ng-container *ngIf="carrier && carrier.preferred">
                <span *ngFor="let carrierCode of carrier.preferred">
                    <fa-icon *ngIf="carrierCode === sectorItem?.carrier?.code" [icon]="iconStar"></fa-icon>
                </span>
            </ng-container>
            <strong class="carrier">{{sectorItem?.carrier?.code}}</strong>
            <span>{{sectorItem.flight}}</span>
        </div>
        <div class="operated" *ngIf="sectorItem.operatedBy">
           {{labels.operatedBy}} {{sectorItem.operatedBy.carrier.code}}
        </div>
        <div *ngIf="getClassCode()">
            <em>{{ labels.classCode}} {{ getClassCode() }}</em>
        </div>
    </div>
    <div class="sector-part carbon-footprint" *ngIf="showCarbonFootprint">
        <carbon-footprint [carbonValue]="sectorItem.carbonFootprint"
                          [referenceValue]="carbonReferenceValue"
                          classList="align-right"></carbon-footprint>
    </div>
</div>
<div class="sector-stop" *ngIf="sectorItem.durationStop">
    <div class="duration">
        <fa-icon [icon]="iconClock"></fa-icon>
        <em *ngIf="sectorItem.durationStop && sectorItem.durationStop.minutes">{{ sectorItem.durationStop.minutes |duration }}</em>
    </div>
    <div class="deco"></div>
</div>
